
const modules = import.meta.glob('./*/*.ts', { eager: true });

const resources: Record<string, any> = {};

Object.keys(modules).forEach((path) => {
  const match = path.match(/\.\/([^/]+)\/([^/]+)\.ts$/);
  if (match) {
    const [, lang, namespace] = match;
    const module = modules[path] as any;
    
    if (!resources[lang]) {
      resources[lang] = {};
    }
    
    // 使用 namespace 作為鍵，模組的 default 導出作為值
    if (module.default) {
      resources[lang][namespace] = module.default;
    }
  }
});

export { resources };
export default resources;
